<template>
  <div class="site-footer" v-show="path!=='/'">
    <el-row class="footer-title">
      <el-col :span="3">
        <el-image style="width: auto; height: 2.5rem;margin-top: 2rem" :src="logo" fit="cover"/>
      </el-col>
      <el-col :offset="12" :span="1" style="padding-right: 1rem">
        首页
      </el-col>
      <el-col  :span="2">
        公司简介
      </el-col>
      <el-col  :span="2">
        产品中心
      </el-col>
      <el-col  :span="2">
        工厂展示
      </el-col>
      <el-col :span="2">
        新闻中心
      </el-col>
    </el-row
    >
    <el-row class="footer-content" style="border-bottom: black">
      <el-col :span="12" style="text-align:left;">
        <el-row id="contact_info">
          <el-col :offset="1" :span="3">
            <el-image style="height: 2rem;" :src="footer_tel" fit="cover"/>
          </el-col>
          <el-col :offset="1" :span="5">
            黄建新（先生）<br> 15558681830 <br>13505844365
          </el-col>
          <el-col :offset="1" :span="13">
            邮箱 <br>sanye@nbdxdrive.com
          </el-col>

          <el-col :offset="5" :span="5">
            电话<br> 0574-63737789 <br>0574-63731972
          </el-col>
          <el-col :offset="1" :span="13">
            地址 <br>浙江省慈溪市龙山镇施公山村工业二道6号楼
          </el-col>

          <el-col :offset="5" :span="5">
            传真<br> 0574-63901865
          </el-col>

        </el-row>

      </el-col>
      <el-col :span="12">
        <el-row style="text-align: center" id="company-content">
          <el-col :offset="5" :span="3">
            公司简介
          </el-col>
          <el-col :offset="1" :span="3">
            公司介绍
          </el-col>
          <el-col :offset="1" :span="3">
            产品内容
          </el-col>
          <el-col :offset="1" :span="3">
            工厂环境
          </el-col>
          <el-col :offset="1" :span="3">
            所有资讯
          </el-col>

          <el-col :offset="5" :span="3">
            企业目标
          </el-col>
          <el-col :offset="1" :span="3">
            车间信息
          </el-col>
          <el-col :offset="5" :span="3">
            机器设备
          </el-col>
          <el-col :offset="1" :span="3">
            公司资讯
          </el-col>

          <el-col :offset="5" :span="3">
            产品中心
          </el-col>
          <el-col :offset="1" :span="3">
            联系我们
          </el-col>
          <el-col :offset="9" :span="3">
            行业资讯
          </el-col>

          <el-col :offset="5" :span="3">
            应用领域
          </el-col>
          <el-col :offset="14" :span="3">

          </el-col>

          <el-col :offset="5" :span="3">
            新闻资讯
          </el-col>
        </el-row>
      </el-col>

    </el-row>

  </div>
</template>

<script setup>
import {useRouter} from 'vue-router'
import logo from "@/assets/img/logo.png";
import footer_tel from "@/assets/img/footer-tel.png";
import {onMounted, ref, watch} from "vue";

const router = useRouter()
let path = ref(router.currentRoute.value.fullPath);


onMounted(() => {
  watch(
      () => router.currentRoute.value.fullPath,
      (newPath) => {
        path.value = newPath;
        console.log("Updated Path:", path.value);
      }
  );
});

</script>


<style scoped>
.site-footer {
  background-color: black;
  bottom: 0;
  width: 100%;
  padding-bottom: 5rem;

}

.footer-title {
  color: white;
  line-height: 5rem;
  text-align: center;
  display: flex;
  align-items: center;
  border-bottom: rgba(255, 255, 255, 0.5) 1px solid;
  width: 90%;
  margin-left: 5%;

}

.footer-content {
  color: white;
  text-align: center;
  display: flex;
  border-bottom: white 1px solid;
  width: 90%;
  margin-left: 5%;
  line-height: 1.5;
}

.footer-content > .el-col:nth-of-type(1),
.footer-content > .el-col:nth-of-type(2) {
  text-align: left;
  margin-top: 2rem;
}

.footer-content > .el-col:not(:nth-of-type(1)):not(:nth-of-type(2)) {
  color: rgba(255, 255, 255, 0.5);
}

.el-row > .el-col {
  font-family: puHuiTi-Medium, sans-serif;
  color: #b3b3b3
}

#contact_info > .el-col:nth-of-type(n+4) {
  margin-top: 1.2rem;
}

#company-content >.el-col:nth-of-type(n+6) {
  margin-top: 0.8rem;
}

</style>